
import { supabase } from '../../supabase';
import { toast } from 'sonner';
import { withRetry } from './retry-service';

/**
 * Retrieves a file from storage
 * @param path Path to the file in storage
 * @returns File data or null if retrieval failed
 */
export async function getFileFromStorage(path: string): Promise<Uint8Array | null> {
  return withRetry(async () => {
    try {
      const { data, error } = await supabase.storage
        .from('papers')
        .download(path);
        
      if (error) {
        console.error('Error downloading file:', error);
        return null;
      }
      
      return new Uint8Array(await data.arrayBuffer());
    } catch (error) {
      console.error('Error retrieving file:', error);
      return null;
    }
  });
}

/**
 * Deletes a file from storage
 * @param path Path to the file in storage
 * @returns True if deletion was successful
 */
export async function deleteFileFromStorage(path: string): Promise<boolean> {
  try {
    const { error } = await supabase.storage
      .from('papers')
      .remove([path]);
      
    if (error) {
      console.error('Error deleting file:', error);
      toast.error('Failed to delete file', {
        description: error.message
      });
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error in delete operation:', error);
    toast.error('An error occurred while deleting the file');
    return false;
  }
}

/**
 * Lists files in a storage folder
 * @param folder Folder path in storage
 * @returns List of files or null if retrieval failed
 */
export async function listFilesInFolder(folder: string): Promise<any[] | null> {
  try {
    const { data, error } = await supabase.storage
      .from('papers')
      .list(folder);
      
    if (error) {
      console.error('Error listing files:', error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error('Error in list operation:', error);
    return null;
  }
}
